import { useStaticQuery, graphql } from 'gatsby';

const useColors = () => {
  const data = useStaticQuery(graphql`
    query useColorsQuery {
      sanityColorsAccent {
        dark {
          color
        }
        darker {
          color
        }
        default {
          color
        }
        light {
          color
        }
        lighter {
          color
        }
        darkCustom {
          hex
        }
        darkerCustom {
          hex
        }
        defaultCustom {
          hex
        }
        lightCustom {
          hex
        }
        lighterCustom {
          hex
        }
      }
      sanityColorsNeutral {
        dark {
          color
        }
        darker {
          color
        }
        default {
          color
        }
        light {
          color
        }
        lighter {
          color
        }
        darkCustom {
          hex
        }
        darkerCustom {
          hex
        }
        defaultCustom {
          hex
        }
        lightCustom {
          hex
        }
        lighterCustom {
          hex
        }
        white {
          color
        }
        black {
          color
        }
      }
      sanityColorsPrimary {
        dark {
          color
        }
        darker {
          color
        }
        default {
          color
        }
        light {
          color
        }
        lighter {
          color
        }
        darkCustom {
          hex
        }
        darkerCustom {
          hex
        }
        defaultCustom {
          hex
        }
        lightCustom {
          hex
        }
        lighterCustom {
          hex
        }
      }
      sanityColorsSecondary {
        dark {
          color
        }
        darker {
          color
        }
        default {
          color
        }
        light {
          color
        }
        lighter {
          color
        }
        darkCustom {
          hex
        }
        darkerCustom {
          hex
        }
        defaultCustom {
          hex
        }
        lightCustom {
          hex
        }
        lighterCustom {
          hex
        }
      }
      sanityColorsHero {
        headline {
          color
        }
        overlayImage {
          color
        }
        overlayVideo {
          color
        }
        tagline {
          color
        }
      }
      sanityColorsNavbar {
        primaryBgColor {
          color
        }
        secondaryBgColor {
          color
        }
      }
    }
  `);

  const colorReducer = (colorCategory) => (result, key) => {
    const targetData = data[`sanityColors${colorCategory}`]?.[key];

    if (key.endsWith('Custom')) {
      const baseKey = key.slice(0, -6); // Remove "Custom" from the end
      if (targetData?.hex) {
        result[baseKey] = targetData.hex;
      }
    } else if (
      targetData &&
      typeof targetData === 'object' &&
      'color' in targetData
    ) {
      // Only set the non-custom color if no custom color has been set
      // or if the key is 'black' or 'white'
      if (!result[key] || key === 'black' || key === 'white') {
        result[key] = targetData.color;
      }
    } else {
      // For any key that's neither a color nor a custom color, directly copy the value
      result[key] = targetData;
    }
    return result;
  };

  const accent = data.sanityColorsAccent
    ? Object.keys(data.sanityColorsAccent).reduce(colorReducer('Accent'), {})
    : {};
  const neutral = data.sanityColorsNeutral
    ? Object.keys(data.sanityColorsNeutral).reduce(colorReducer('Neutral'), {})
    : {};
  const primary = data.sanityColorsPrimary
    ? Object.keys(data.sanityColorsPrimary).reduce(colorReducer('Primary'), {})
    : {};
  const secondary = data.sanityColorsSecondary
    ? Object.keys(data.sanityColorsSecondary).reduce(
        colorReducer('Secondary'),
        {}
      )
    : {};
  const hero = data.sanityColorsHero
    ? Object.keys(data.sanityColorsHero).reduce(colorReducer('Hero'), {})
    : {};
  const navbar = data.sanityColorsNavbar
    ? Object.keys(data.sanityColorsNavbar).reduce(colorReducer('Navbar'), {})
    : {};

  return {
    accent,
    neutral,
    primary,
    secondary,
    hero,
    navbar,
  };
};

export { useColors };
